<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
  html, body {
    margin: 0px;
    padding: 0;
    height: 100%;
  }
  #app {
    height: 100%;
  }

  @media screen and (max-width: 768px) {
    input, textarea, select {
      font-size: 16px !important;
    }
    .el-input {
      --el-input-font-size: 16px !important;
    }

    .el-input__inner {
      font-size: var(--el-input-font-size) !important;
    }
  }
</style>
